import { UI } from 'components/_Assets/svg/Icon/ui'
import { Button, TYPE } from 'components/Button'
import Heading from 'components/Heading'
import Icon from 'components/Icon'
import Section, { SectionType, Size } from 'components/Section/Section'
import StatusCode from 'components/StatusCode'
import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { Slink } from '../routing/links'
import Content from './shared/content'
import Page from './shared/page_wrapper'

interface NotFoundProps {
  match: any
}

export const NotFound: React.FC<NotFoundProps> = ({ match }) => (
  <Page page="not-found" match={match} navFooter stopTracking>
    <Section type={SectionType.solid} size={Size.s}>
      <StatusCode code={404} />

      <Heading>
        <Content contentKey="status-code-404-heading">
          Did you hope to land somewhere differently?
        </Content>
      </Heading>

      <p>
        <Content contentKey="status-code-404-story">
          While you are here, we might as well tell you about John. He is the
          kind of srsps.traveller where nothing goes as intended. Let’s suggest,
          he orders a croque at lunchtime. You can be sure then he won’t be
          setting his teeth in a croque, but in a croquette. Or when he does his
          laundry and throws two light blue socks in his washing machine, he
          ends up with one pink sock. And when he takes the train once a year,
          chances are astronomical that his train breaks down and strands after
          two or three stops. Yet with his mellow, ‘take it as it is’ outlook on
          life, John just can’t be bothered. Growing up, his mother taught him
          the value of surprises, unexpected situations and simply welcoming any
          situation. The greatest and most valuable surprises he learned, come
          in the most unexpected packages. Like the night when John stranded on
          a train station while having to endure temperatures well below
          freezing point. Before he knew it, a stranger came to the rescue and
          invited him into his home. As it turned out, this man’s mansion gave
          home to the world’s largest museum of socks. His collection counted
          over 1485 pairs and even contained the socks of Ronaldinho when he
          made history in 2002 with his phenomenal free kick. The owner of the
          museum was so impressed by John’s unusual flair for combining socks,
          he hoped to add them to his collection in return for a delicious meal.
          The man disappeared into his kitchen to shortly after return with a
          very distinguished croque monsieur: a croque with a layer of ragout
          added to the mix. John had tasted the exact same croque once before,
          but couldn’t figure out where or when, no matter how hard he racked
          his brain. When the man dropped him off at the station of his final
          destination, John couldn’t help but think back to what his mother
          repeatedly told him when he was little. Everything that day took a
          different course than planned, but it sure made the day one heck of a
          memorable one. Who knows this very moment is the beginning of
          something completely anew and unexpected. A seemingly random moment
          that will nevertheless stay ingrained into your memory forever.
        </Content>
      </p>
      <br />
      <Slink name="about">
        <Button cutOff={'left'}>
          <span>
            <DisplayContent edit={true} contentKey="status-code-404-button">
              Find here what you weren’t looking for
            </DisplayContent>
          </span>
          <Icon icon={UI.chevronRight} />
        </Button>
      </Slink>
    </Section>
    <Section type={SectionType.solid} noPadding={true}>
      {/* This Section is empty on purpose */}
    </Section>
  </Page>
)
